/** Strings for the livechat page header: tools menu, agent menu, test mode and availability hints. */
export const translationLivechat_da_header = {
  livechatToolsMenuLabel: "Indstillinger og værktøjer",
  livechatSettingsHint: "Tilgængelighed, widget, oversættelse, routing, inaktive chats og data",
  livechatCannedResponsesHint: "Administrer gemte svar",
  livechatGroupsHint: "Vælg hvem der modtager routede chats",
  livechatTestMode: "Testtilstand",
  livechatTestModeHint: "Vis kun chats fra testportaler",
  livechatTestModeBarTitle: "Testtilstand.",
  livechatTestModeBarText:
    "Du ser kun chats fra testportaler. Live-chats kommer fortsat ind i live-køen.",
  livechatBackToLive: "Tilbage til live",
  livechatAgentMenuLabel: "Din agentprofil og notifikationer",
  livechatAgentProfileHint: "Navn, billede og sprog som besøgende ser",
  livechatAgentProfileHintAllChatbots: "Navn, billede og sprog som besøgende ser på alle chatbots",
  livechatNotifyMe: "Giv mig besked om",
  livechatPopupShort: "Pop-ups",
  livechatPopupHint: "En besked når der er ny aktivitet i live chat",
  livechatOtherAgentsShort: "Chats som andre agenter håndterer",
  livechatOtherAgentsHint: "Når slået fra, får du kun besked om dine egne og ikke-tildelte chats",
  livechatGoOnlineHint: "Også uden for åbningstiden",
  livechatGoOfflineHint: "Besøgende ser kontaktformularen",
  livechatUseScheduleHint: "Følg hver chatbots åbningstider",
  livechatAvailabilityOneChatbot: "Skift én chatbot",
  livechatEditOpeningHours: "Rediger åbningstider",
};
